@if (allowed) { @if (isSubEntitlements) {
<div class="allowed-dataset-label">
  <firebird-web-icon
    width="1.5rem"
    height="1.5rem"
    name="check-circle"
  ></firebird-web-icon>
  <p>{{ 'enhancedDataServicesAccessDataset' | translate }}</p>
</div>
<ul>
  @for ( subEntitlement of subEntitlements; track trackBySubEntitlement($index,
  subEntitlement)) {
  <li>
    {{ subEntitlement }}
  </li>
  }
</ul>
} @else {
<firebird-web-icon
  width="1.5rem"
  height="1.5rem"
  name="check-circle"
></firebird-web-icon>
<p>{{ 'enhancedDataServicesAccess' | translate }}</p>
} } @else {
<p>
  {{ 'enhancedDataServicesNoAccess' | translate }}
  <a
    href="mailto:sales@atmosphericg2.com?subject=Interested in trialing SUN API Services"
  >
    sales&#64;atmosphericg2.com
  </a>
</p>
}
